import React, { Component } from "react";
import trash from "views/profile/img/delete-2.svg";
import edit from "views/profile/img/edit.svg";
import { ChevronLeft, ChevronDown } from "react-feather";
import {
  getLANGUAGEMASTERAction,
  getSKILLMASTERAction,
  getRATINGMASTERAction,
} from "store/masters";
import {
  getlanguageAction,
  setLanguageAction,
  getSkillAction,
  saveSkillAction,
  getCertificationAction,
  saveCertificationAction,
  getPublicationAction,
  savePublicationAction,
} from "store/userWalkthrough";
import { connect } from "react-redux";
import kyc from "views/profile/img/kyc/kyc.png";
class Skill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddDetailsSkill: true,
      Remarks: "",
      Proficiency: null,
      SkillId: null,
    };
  }

  async saveSkills(e) {
    e.preventDefault();
    let SkillDataJson = [
      {
        SkillId: this.state.SkillId,
        Proficiency: this.state.Proficiency,
        Remarks: this.state.Remarks,
      },
    ];

    var obj = {
      CandidateNo: this.props.Auth.HCID,
      SkillData: SkillDataJson,
    };
    let response = await this.props.saveSkillAction(obj);
    if (response.ResponseCode == 100) {
      await this.setState({ isAddDetailsSkill: true });
      let skillResponse = await this.props.getSkillAction(this.props.Auth.HCID);
    } else {
      alert(response.ResponseMessage);
    }
  }

  async componentDidMount() {
    this.props.getSKILLMASTERAction();
    this.props.getRATINGMASTERAction();
  }
  async emptyState() {
    this.setState({
      Remarks: "",
      Proficiency: null,
      SkillId: null,
    });
  }
  async editSkill(x) {
    this.setState({
      isAddDetailsSkill: false,
      Remarks: x.Remarks,
      Proficiency: x.Proficiency,
      SkillId: x.SkillId,
    });
  }
  render() {
    return (
      <div className="">
        {this.state.isAddDetailsSkill && (
          <div>
            <div>
              {/* Skills */}

              <div>
                <div className="flex justify-between ">
                  <div className="flex justify-between items-center w-full">
                    <p className="fsize16 text-black font-semibold">Skills</p>

                    <button
                      className="outline-btn fsize16  misc-w158px font-semibold w-200px uppercase"
                      onClick={() => {
                        this.setState({
                          isAddDetailsSkill: !this.state.isAddDetailsSkill,
                        });
                        this.props.setSkillView();
                        this.emptyState();
                      }}
                    >
                      ADD
                    </button>
                  </div>
                </div>
                <div className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-8 mt-4">
                  {/* languages */}
                  {this.props.SKILLDETAILS
                    ? this.props.SKILLDETAILS.Data.map((x) => {
                      return (
                        <card className="rounded-sm borderblue-t-5px  drop-shadow20 bg-white block px-6 py-4 ">
                          <div className="flex justify-between 	">
                            <p className="text-black font-bold fsize16">
                              {x.SkillName}
                            </p>
                            <div className="flex items-center">
                              <img
                                src={edit}
                                alt="edit"
                                className="text053C6D w-5 h-5 "
                                onClick={() => this.editSkill(x)}
                              />
                            </div>
                          </div>
                          <p className="border707070-t opacity-20 my-4 	"></p>
                          <div>
                            <div className="flex justify-between mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                Proficiency
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                {x.ProficiencyName}
                              </p>
                            </div>{" "}
                            <div className="flex justify-between mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                Remarks
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                {x.Remarks}
                              </p>
                            </div>
                          </div>
                        </card>
                      );
                    })
                    : " "}
                </div>
              </div>
              <div className="divider-card-b opacity-30 mt-8 mb-4"></div>
              {/* Certifications */}
            </div>
          </div>
        )}

        {!this.state.isAddDetailsSkill && (
          <>
            <div className="relative">
              <form onSubmit={(e) => this.saveSkills(e)}>
                <div className="transform-tab cursor-pointer lg:block md:block hidden">
                  {/* <div className="flex justify-evenly items-center bgFDF1E7 rounded-8px h-41px w-200px">
                    <p className="text-black opacity-65 fsize14 font-semibold ">
                      Open Resume Tab
                    </p>
                    <ChevronDown className="text053C6D" />
                  </div> */}
                </div>
                <div>
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() =>
                      this.setState({
                        isAddDetailsSkill: !this.state.isAddDetailsSkill,
                      })
                    }
                  >
                    <ChevronLeft className="text053C6D" />
                    <p
                      className="text-black fsize16 pl-2 font-semibold"
                      onClick={() => {
                        this.emptyState();
                      }}
                    >
                      Go back
                    </p>
                  </div>
                </div>
                <div className="mt-2 lg:w-3/4 md:w-3/4 w-full lg:pl-6 md:pl-6">
                  <div className="lg:flex md:flex items-center mb-1">
                    <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                      <label for="">Skill</label>
                      <div class="relative w-full right-0 rail-select">
                        <div class="select-side">
                          {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                          <ChevronDown className="text053C6D" />
                        </div>
                        <select
                          className="select-dropdown-c fsize15"
                          value={this.state.SkillId || -1}
                          onChange={(e) =>
                            this.setState({ SkillId: e.target.value })
                          }
                        >
                          <option value='-1' disabled>
                            Select
                          </option>
                          {this.props.SKILL
                            ? this.props.SKILL.Data
                              ? this.props.SKILL.Data.map((x) => {
                                return (
                                  <option value={x.Value}>{x.Title}</option>
                                );
                              })
                              : ""
                            : ""}
                        </select>
                      </div>
                    </div>

                    <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                      <label for="">Proficiency</label>
                      <div class="relative w-full right-0 rail-select">
                        <div class="select-side">
                          {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                          <ChevronDown className="text053C6D" />
                        </div>
                        <select
                          className="select-dropdown-c fsize15"
                          value={this.state.Proficiency || -1}
                          onChange={(e) =>
                            this.setState({ Proficiency: e.target.value })
                          }
                        >
                          <option value="-1" disabled>
                            Select
                          </option>
                          {this.props.RATING
                            ? this.props.RATING.Data
                              ? this.props.RATING.Data.map((x) => {
                                return (
                                  <option value={x.Value}>{x.Title}</option>
                                );
                              })
                              : ""
                            : ""}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 lg:w-3/4 md:w-3/4 w-full ">
                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                        <label for="">Remarks</label>

                        <input
                          required
                          type="text"
                          placeholder=""
                          className=" fsize16"
                          value={this.state.Remarks}
                          onChange={(e) => {
                            this.setState({ Remarks: e.target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-right sm-flex lg:mt-16 md:mt-16 mt-10">
                  <button
                    className="outline-button outline-border2px mis-add-btn w-230px sm-fsize14 h-50px font-semibold rounded-25px fsize16 mr-4"
                    onClick={() => {
                      this.setState({
                        isAddDetailsSkill: !this.state.isAddDetailsSkill,
                      });
                      this.props.setSkillView();
                      this.emptyState();
                    }}
                  >
                    CANCEL
                  </button>
                  <button
                    className="filled-button w-230px filled-border2px sm-fsize14 h-50px  font-semibold rounded-25px fsize16 ml-4"
                    type="submit"
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
            <div className="divider-card-b opacity-30 mt-8 mb-4"></div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    LANGUAGEDETAILS: state.userWalkthrough.info.LANGUAGEDETAILS,
    SKILLDETAILS: state.userWalkthrough.info.SKILLDETAILS,
    RATING: state.master.info.RATING,
    SKILL: state.master.info.SKILL,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getlanguageAction: async (payload) =>
      await dispatch(getlanguageAction(payload)),
    setLanguageAction: async (payload) =>
      await dispatch(setLanguageAction(payload)),
    getSKILLMASTERAction: async (payload) =>
      await dispatch(getSKILLMASTERAction(payload)),
    getRATINGMASTERAction: async (payload) =>
      await dispatch(getRATINGMASTERAction(payload)),

    getSkillAction: async (payload) => await dispatch(getSkillAction(payload)),
    getCertificationAction: async (payload) =>
      await dispatch(getCertificationAction(payload)),
    getPublicationAction: async (payload) =>
      await dispatch(getPublicationAction(payload)),

    saveSkillAction: async (payload) =>
      await dispatch(saveSkillAction(payload)),
    saveCertificationAction: async (payload) =>
      await dispatch(saveCertificationAction(payload)),
    savePublicationAction: async (payload) =>
      await dispatch(savePublicationAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Skill);
